import { atomFamily } from 'recoil';

import { DialogId } from './types';

const playgroundId = atomFamily<DialogId, string>({
  key: 'playground-chainlet-id-state',
  default: null,
});

const autoScalingVersionId = atomFamily<string, string>({
  key: 'auto-scaling-chainlet-id-state',
  default: null,
});

const apiEndpointId = atomFamily<DialogId, string>({
  key: 'api-endpoint-version-id-state',
  default: null,
});

const configurePromotionEnvId = atomFamily<string, string>({
  key: 'is-configure-promotion-dialog-open-state',
  default: null,
});

export { configurePromotionEnvId, playgroundId, autoScalingVersionId, apiEndpointId };
